import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import "./globals/index.scss";
import "./services/Offline";
import NoPage from "./pages/NoPage/NoPage";
import Layout from "./pages/Layout/Layout";
import LayoutSga from "./pages/Layout/sga/LayoutSga";
import CadastroJornada from "./pages/Cadastro/CadastroJornada";
import { LayoutInterno } from "./pages/Layout/interno/LayoutInterno";
import { RecodeProNavMenu } from "./pages/Layout/RecodeProNavMenu";
import LayoutMini from "./pages/Layout/mini/LayoutMini";
// import Home from "./pages/Home/Home";
import Sgr from "./pages/Sgr/Sgr";
import Login from "./pages/Login/Login";
// import CadastroRecodePro from "./pages/Cadastro/CadastroRecodePro";
// import CadastroAldeia from "./pages/Cadastro/CadastroAldeia";
import CadastroQot from "./pages/Cadastro/CadastroQot";
import { AuthProvider, Private } from "./services/Auth";
import RecodePro from "./pages/Sgr/Recodepro/Recodepro";
import Classificados from "./pages/Sgr/Recodepro/RecodeproClassificados";
import ValidaDoc from "./pages/Sgr/Recodepro/RecodeproValidaDoc";
import EnviarDocumentos from "./pages/EnviarDocumentos/EnviarDocumentos";
import Termos from "./pages/Termos/Termos";
import Aprovados from "./pages/Sgr/Recodepro/RecodeproAprovados";
import SelecionarPerfil from "./pages/Cadastro/es/SelecionarPerfil";
import CadastroEsAluno from "./pages/Cadastro/es/CadastroEsAluno";
import CadastroEsEducador from "./pages/Cadastro/es/CadastroEsEducador";
import CadastroEsInstituicao from "./pages/Cadastro/es/CadastroEsInstituicao";
import CadastroJanelas from "./pages/Cadastro/janelas/CadastroJanelas";
import CadastroAldeia from "./pages/Cadastro/CadastroAldeia";
import CadastroPovosDaFloresta from "./pages/Cadastro/CadastroPovosDaFloresta";
import CadastroTechSP from "./pages/Cadastro/smit/CadastroTechSP";
import CadastroForms from "./pages/Cadastro/forms/CadastroForms";
import CadastroImpactAI from "./pages/Cadastro/smit/CadastroImpactAI";

export default function App() {
  function RedirectToRecode() {
    // redirect to external URL
    window.location.replace("https://recodepro.org.br/");
    return null;
  }

  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/" element={<LayoutMini />}>
            <Route index element={<RedirectToRecode />} />
            <Route path="*" element={<NoPage />} />
          </Route>

          <Route
            path="sgr"
            element={
              <Private>
                <LayoutInterno />
              </Private>
            }
          >
            <Route index element={<Sgr />} />
            <Route path="recodepro" element={<RecodeProNavMenu />}>
              <Route index element={<RecodePro />} />
              <Route path="classificados" element={<Classificados />} />
              <Route path="aprovados" element={<Aprovados />} />
              <Route path="validadoc" element={<ValidaDoc />} />
            </Route>
          </Route>

          <Route path="login" element={<LayoutMini />}>
            <Route index element={<Login />} />
          </Route>

          <Route path="cadastro">
            <Route element={<Layout />}>
              <Route index element={<RedirectToRecode />} />
              <Route path="recodepro" element={<RedirectToRecode />} />
              <Route path="aldeia" element={<CadastroAldeia />} />
              <Route
                path="povosDaFloresta"
                element={<CadastroPovosDaFloresta />}
              />
              <Route path="qot" element={<CadastroQot />} />

              <Route path="ES">
                <Route index element={<SelecionarPerfil />} />
                <Route path="aluno" element={<CadastroEsAluno />} />
                <Route path="educador" element={<CadastroEsEducador />} />
                <Route path="instituicao" element={<CadastroEsInstituicao />} />
              </Route>
            </Route>

            <Route element={<LayoutSga />}>
              <Route path="jornada" element={<CadastroJornada />} />
            </Route>

            <Route path="escolas" element={<CadastroJanelas />} /> 
            <Route path="techSP" element={<CadastroTechSP />} />
            <Route path="impactAI" element={<CadastroImpactAI />} />
            <Route path="forms" element={<CadastroForms />} />
          </Route>

          <Route path="recodePro" element={<Layout />}>
            <Route index element={<RedirectToRecode />} />
            <Route path="termos/:idestudante" element={<Termos />} />
            <Route path="enviarDocumentos">
              <Route path=":idestudante" element={<EnviarDocumentos />} />
            </Route>
          </Route>
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}
